import Vue from "vue";
import Swiper, {Autoplay} from "swiper";

Swiper.use([Autoplay]);

window.Vue = require("vue");
window.axios = require("axios");

Vue.component(
    "mailchimp-optin",
    require("./components/MailchimpOptin.vue").default,
);
Vue.component(
    "donation-form",
    require("./components/DonationForm.vue").default,
);
Vue.component(
    "supporter-form",
    require("./components/SupporterForm.vue").default,
);
Vue.component(
    "form-error",
    require("./components/FormError.vue").default,
);

if (document.getElementById("app")) {
    new Vue({
        el: "#app",
    });
}

window.onload = (event) => {
    addMobileMenuClickHandler();
    addScrollToElementClickHandler();
};

function addMobileMenuClickHandler() {
    const mobileMenu = document.getElementById("js-mobile-menu");

    document
        .getElementById("js-open-mobile-menu")
        .addEventListener("click", (event) => {
            showElement(mobileMenu);
        });

    document
        .getElementById("js-close-mobile-menu")
        .addEventListener("click", (event) => {
            hideElement(mobileMenu);
        });
}

function showElement(element) {
    element.classList.remove("hidden");
    element.classList.add("block");
}

function hideElement(element) {
    element.classList.remove("block");
    element.classList.add("hidden");
}

function addScrollToElementClickHandler() {
    const elements = document.getElementsByClassName("js-scroll-link");
    const mobileMenu = document.getElementById("js-mobile-menu");

    [...elements].some((element) => {
        element.addEventListener("click", (event) => {
            if (document.getElementById(event.target.dataset.scrollTargetId) === null) {
                return;
            }

            event.preventDefault();
            hideElement(mobileMenu);
            scrollToElement(event.target.dataset.scrollTargetId);
        });
    });
}

function getCalculatedElementTopPosition(element) {
    return (
        window.pageYOffset -
        document.getElementById("header").clientHeight +
        element.getBoundingClientRect().top
    );
}

function scrollToElement(elementId) {
    const topOfElement = getCalculatedElementTopPosition(
        document.getElementById(elementId),
    );

    window.scroll({top: topOfElement, behavior: "smooth"});
    history.pushState(null, null, `#${elementId}`);
}

window.scrollToElement = function (elementId) {
    scrollToElement(elementId);
};

window.addEventListener("scroll", function (event) {
    const headerClassList = document.getElementById("header").classList;

    if (window.pageYOffset > 400) {
        headerClassList.add("shadow-header");
        return;
    }

    headerClassList.remove("shadow-header");
});


var swiper = new Swiper(".swiper-container", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    rtl: false,
    freeMode: true,
    centeredSlided: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    breakpoints: {
        640: {
            slidesPerView: 3,
            centeredSlided: false,
        },
        1280: {
            slidesPerView: 4,
        },
        1536: {
            slidesPerView: 5,
            spaceBetween: 60,
        },
        1920: {
            slidesPerView: 5,
            spaceBetween: 60,
        },
    },
});

/*
['name', 'message', 'city'].forEach(function (fieldName) {
    let field = document.getElementById(fieldName);

    if (!field) {
        return;
    }

    field.addEventListener('keyup', function (event) {
        let fieldContent = event.target.value;
        let previewContent = document.getElementById(`${fieldName}Preview`);

        if (fieldContent.length > 0) {
            previewContent.innerText = fieldContent;
        } else {
            previewContent.innerText = event.target.getAttribute('placeholder');
        }
    })
})

let charsInMessageLeft = 160;

function updateMessageCharsCounter() {
    document.getElementById('charCounter').innerText = charsInMessageLeft;
}

let messageInput = document.getElementById('message');
if (messageInput) {
    messageInput.addEventListener('keyup', (event) => {
        charsInMessageLeft = 160 - event.target.value.length;
        updateMessageCharsCounter();
    });

    updateMessageCharsCounter();
}


*/
